<div class="container">
  <div class="search-section">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText type="text" [(ngModel)]="searchKey" placeholder="Search.." class="p-inputtext-sm" (keyup.enter)="searchCustomer()"/>
      <p-button icon="pi pi-search" (onClick)="searchCustomer()" [style]="{'margin': '5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button>
    </span>
  </div>
  <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info" class="refresh-button"></p-button>
</div>

    <p-table #dt1 [value]="customers" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
        selectionMode="single" [loading]="loader" (onRowSelect)="SelectOption($event)" [paginator]="true" [rows]="5" 
        [rowsPerPageOptions]="[5, 10, 20]" (onPage)="load($event)" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>Customer Code</th>
                <th>Customer Name</th>
                <th>City</th>
                <th>State</th>
                <th>Country</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
            <tr (click)="SelectOption(customer)">
                <td>
                    <p-tableRadioButton [value]="customer"></p-tableRadioButton>
                </td>
                <td>{{ customer.customerCode }}</td>
                <td>{{ customer.customerName }}</td>
                <td>{{ customer.address ? customer.address.city : ''}}</td>
                <td>{{ customer.address ? customer.address.state : ''}}</td>
                <td>{{ customer.address ? customer.address.country : ''}}</td>

            </tr>
        </ng-template>
    </p-table>
